import React from 'react';

const PrivacyPolicy = () => (
  <div style={{maxWidth: 700, margin: '40px auto', padding: 24, background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px #eee'}}>
    <h1 style={{color: '#203a43', fontSize: 32, marginBottom: 16}}>Privacy Policy</h1>
    <p style={{fontSize: 18, color: '#444', marginBottom: 28}}>
      Your privacy is extremely important to us. We only collect and use your data to provide and improve our services. <b>We do not sell your data to third parties.</b>
      <br /><br />
      For any questions or details, contact us at <a href="mailto:your-email@example.com" style={{color: '#2a5298'}}>your-email@example.com</a>.
    </p>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>What Data We Collect</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 28, paddingLeft: 24}}>
      <li>Email address and profile info (for authentication)</li>
      <li>Application details you submit</li>
      <li>Usage analytics (anonymized)</li>
    </ul>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>How We Use Your Data</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 28, paddingLeft: 24}}>
      <li>To provide secure access to the app</li>
      <li>To process your applications</li>
      <li>To improve our services</li>
    </ul>

    <h2 style={{color: '#203a43', fontSize: 24, marginTop: 32, marginBottom: 10}}>Your Rights</h2>
    <ul style={{fontSize: 17, color: '#555', marginBottom: 16, paddingLeft: 24}}>
      <li>You may request deletion of your data at any time.</li>
      <li>Contact us for any privacy concerns.</li>
    </ul>

    <div style={{marginTop: 24, background: '#f9f9f9', padding: 18, borderRadius: 8, color: '#203a43', fontWeight: 500, fontSize: 16}}>
      <span role="img" aria-label="info">🔒</span> <b>Your privacy and trust are our top priorities.</b> We are committed to keeping your information safe and transparent about how we use it.
    </div>
  </div>
);

export default PrivacyPolicy;
